import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { AdmissionsProspectsService } from '../admissions-prospects.service';
import { AllApplicationsViewPart } from "./all-applications/all-applications.part";
import { AllProspectsViewPart } from './all-prospects/all-prospects.part';
import { ProspectsClosedLeadsViewPart } from './closed-leads/closed-leads.part';
@Component({
	selector: 'admissions-prospects-views-part',
	standalone: true,
	imports: [
		DroplistWidget,
		AllProspectsViewPart,
		AllApplicationsViewPart,
		ProspectsClosedLeadsViewPart,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './prospects-views.part.html',
})
export class AdmissionsProspectsViewsPart implements OnInit {

	public service = inject(AdmissionsProspectsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}